module.exports = __webpack_public_path__ + "static/media/instragram4.6b22e13c.jpg";